import ErrorView from './Error.view';

export default ErrorView;
